module.exports = __webpack_public_path__ + "static/media/icon_input_cross.c216bf32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_input_cross.svg
// module id = 145
// module chunks = 1